import type { FC } from 'react';
import { ListCollectionWrapper } from './List.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface ListCollectionProps { }

const ListCollection: FC<ListCollectionProps> = () => (
   <ListCollectionWrapper>
      <header className="entry-header">
         <h1 className="entry-title" itemProp="headline">List</h1>
      </header>
      <br/>
      <div className="entry-content clear" itemProp="text">
         <p className="text-align-justify">
            Lists represent an ordered collection of elements. It can have duplicate values. The classes ArrayList, LinkedList, Vector, and Stack implements List Interface.
            <br />Syntax :
            <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
               {
                  'a) List list1 = new ArrayList();\n' +
                  'b) List list2 = new LinkedList();\n' +
                  'c) List list3 = new Vector();\n' +
                  'd) List list4 = new Stack();'
               }
            </SyntaxHighlighter>
         </p>
         <br/>
         <p style={{ fontWeight: 'bold', fontSize: '20px' }} className="text-align-justify has-custom-weight">Types of List :</p>
         <ul className="text-align-justify">
            <li><strong>ArrayList :</strong>
               <ul>
                  <li>The ArrayList class implements the List interface.</li>
                  <li>Basically, it uses a dynamic array to store the elements.</li>
                  <li>In addition, it maintains the insertion order and is non-synchronized.</li>
                  <li>One can randomly access the elements stored in the ArrayList class.</li>
                  <li>Eg :
                  <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                     {
                        'ArrayList list = new ArrayList(); //Creating arraylist\n'+
                        'list.add(“Ram”); //Adding object in arraylist'
                     }
                  </SyntaxHighlighter>
                  </li>
               </ul>
            </li>
            <br/>
            <li><strong>LinkedList :</strong>
               <ul>
                  <li>The LinkedList class implements the List interface.</li>
                  <li>Basically, it uses a doubly linked list internally to store the elements.</li>
                  <li>In addition, it maintains the insertion order and is not synchronized.</li>
                  <li>In the LinkedList, the manipulation is fast because no shifting is required.</li>
                  <li>Eg :
                  <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                     {
                        'LinkedList list = new LinkedList();\n'+
                        'list.add(“Ram”);'
                     }
                  </SyntaxHighlighter>
                  </li>
               </ul>
            </li>
            <br/>
            <li><strong>Vector :</strong>
               <ul>
                  <li>Vector basically uses a dynamic array to store the data elements.</li>
                  <li>It is similar to ArrayList.</li>
                  <li>It is synchronized.</li>
                  <li>It contains many methods that are not part of the Collection framework.</li>
                  <li>Eg :
                  <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                     {
                        'Vector v = new Vector();\n'+
                        'v.add(“Ram”);'
                     }
                  </SyntaxHighlighter>
                  </li>
               </ul>
            </li>
            <br/>
            <li><strong>Stack :</strong>
               <ul>
                  <li>A stack is the subclass of Vector and contains all of the methods of Vector class.</li>
                  <li>In addition, it implements the last-in-first-out LIFO data structure.</li>
                  <li>Eg :
                  <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                     {
                        'Stack stack = new Stack();\n'+
                        'stack.push(“Ram”);\n'+
                        'stack.pop();'
                     }
                  </SyntaxHighlighter>
                  </li>
               </ul>
            </li>
         </ul>
      </div>
   </ListCollectionWrapper>
);

export default ListCollection;
